export const cdp = {
	tabs: {
		dashboard: "CDP Dashboard",
		customers: "Customer List",
		rfmAnalysis: "RFM Analysis",
		segments: "Segments",
	},
	dashboard: {
		title: "CDP Dashboard",
		subtitle: "Track your customers, relationship metrics and intelligent segmentation",
		filters: {
			period: {
				label: "Period",
				options: {
					last7Days: "Last 7 days",
					last15Days: "Last 15 days",
					last30Days: "Last 30 days",
					last60Days: "Last 60 days",
					last90Days: "Last 90 days",
				},
			},
			groupBy: {
				label: "Group by",
				options: {
					week: "Week",
					month: "Month",
				},
			},
			establishments: {
				label: "Establishments",
				all: "All",
			},
		},
	},
	customers: {
		title: "Customer List",
		subtitle: "Search and filter customers from your database",
		filters: {
			search: {
				placeholder: "Search by name, email, phone or document...",
			},
			rfmClassification: {
				label: "RFM Classification",
				placeholder: "All classifications",
			},
			segments: {
				label: "Segments",
				placeholder: "All segments",
			},
			allowCommunication: {
				label: "Allows Communication",
				all: "All",
				yes: "Yes",
				no: "No",
			},
			lastInteraction: {
				label: "Last Interaction",
				last7Days: "Last 7 days",
				last30Days: "Last 30 days",
				moreThan90Days: "More than 90 days",
				custom: "Custom",
			},
			balance: {
				label: "Available Balance",
				onlyWithBalance: "Only with balance",
				minBalance: "Minimum balance ($)",
			},
			activityPeriod: {
				label: "Activity Period",
				from: "From",
				to: "To",
			},
			actions: {
				apply: "Apply Filters",
				clear: "Clear Filters",
			},
			results: "{{count}} customers found",
		},
		table: {
			columns: {
				name: "Name",
				contact: "Contact",
				classification: "Classification",
				behavior: "Behavior",
				totalPaid: "Total paid",
				averageTicket: "Avg Ticket",
				actions: "Actions",
			},
			visits: "{{count}} visits",
			lastVisit: "Last visit",
			ago: "{{days}} days ago",
			totalPaid: "Total paid",
			averageTicket: "Average ticket",
			balance: "Balance",
			viewDetails: "View Details",
			noResults: "No customers found",
			noResultsDescription: "Try adjusting your filters to find customers",
		},
		status: {
			active: "Active",
			attention: "Attention",
			risk: "Risk",
			inactive: "Inactive",
		},
		drawer: {
			title: "Customer Details",
			tabs: {
				summary: "Summary",
				favoriteProducts: "Favorite Products",
				history: "History",
				purchases: "Purchases",
			},
			summary: {
				personalData: "Personal Data",
				document: "Document",
				email: "Email",
				phone: "Phone",
				birthDate: "Birth Date",
				gender: "Gender",
				city: "City",
				allowsCommunication: "Allows Communication",
				activitySummary: "Activity Summary",
				firstVisit: "First Visit",
				lastVisit: "Last Visit",
				totalVisits: "Total Visits",
				averageFrequency: "Average Frequency",
				visitsPerMonth: "visits/month",
				customerFor: "Customer for {{days}} days",
				financial: "Financial",
				totalPaid: "Total Paid",
				averageTicket: "Average Ticket",
				availableBalance: "Available Balance",
				classifications: "Classifications",
				rfmByPlace: "RFM by Establishment",
				segments: "Segments",
			},
			products: {
				product: "Product",
				category: "Category",
				quantity: "Quantity",
				totalValue: "Total Value",
				lastPurchase: "Last Purchase",
				percentageOfPurchases: "% of Purchases",
				noProducts: "No favorite products found",
			},
			history: {
				filterByType: "Filter by type",
				allTypes: "All types",
				loadMore: "Load more",
				noHistory: "No history found",
			},
			purchases: {
				product: "Product",
				category: "Category",
				quantity: "Qty",
				unitPrice: "Unit Price",
				total: "Total",
				date: "Date",
				noPurchases: "No purchases found",
				loadMore: "Load more",
			},
			actions: {
				close: "Close",
				addToSegment: "Add to Segment",
				edit: "Edit",
			},
		},
		genders: {
			male: "Male",
			female: "Female",
			other: "Other",
			unknown: "Not informed",
		},
		interactionTypes: {
			presence: "Presence",
			recharge: "Recharge",
			giftbackRescue: "Giftback Rescue",
			giftbackExpire: "Giftback Expiration",
			giftbackReceive: "Giftback Receive",
			ticketPurchase: "Ticket Purchase",
			ticketCancel: "Ticket Cancel",
			communication: "Communication",
			rfmMigration: "RFM Migration",
		},
	},
	segments: {
		title: "Segments",
		subtitle: "Create and manage custom customer segments",
		summary: {
			highestRevenue: "Highest revenue segment",
			highestTicket: "Highest avg ticket segment",
			mostCustomers: "Segment with most customers",
			leastCustomers: "Segment with fewest customers",
		},
		search: {
			placeholder: "Search segment...",
		},
		actions: {
			create: "Create segment",
			edit: "Edit",
			delete: "Delete",
			duplicate: "Duplicate",
		},
		card: {
			createdBy: "Created by: {{name}}",
			leads: "{{count}} leads",
			lastSync: "Last sync: {{date}}",
			neverSynced: "Never synced",
		},
		drawer: {
			titleCreate: "Create segment",
			titleEdit: "Edit segment",
			fields: {
				name: "Name",
				namePlaceholder: "Segment name",
				description: "Description",
				descriptionPlaceholder: "Describe the purpose of this segment",
				analysisPeriod: "Analysis period (days)",
				analysisPeriodPlaceholder: "E.g.: 30",
			},
			rules: {
				title: "Segmentation Rules",
				demographic: "Demographic",
				consumption: "Consumption",
				engagement: "Engagement",
				status: "Status",
				gender: {
					label: "Gender",
					male: "Male",
					female: "Female",
					other: "Other",
				},
				birthday: {
					label: "Birthday",
					thisMonth: "This month",
					nextMonth: "Next month",
					thisWeek: "This week",
					nextWeek: "Next week",
				},
				minFrequency: {
					label: "Minimum frequency",
					placeholder: "Minimum purchases in period",
				},
				minPresences: {
					label: "Minimum visits",
					placeholder: "Minimum visits in period",
				},
				minTotalPaid: {
					label: "Minimum total value",
					placeholder: "$ 0.00",
				},
				minAvgTicket: {
					label: "Minimum average ticket",
					placeholder: "$ 0.00",
				},
				maxLastInteraction: {
					label: "Time since last purchase",
					placeholder: "Maximum days",
					suffix: "days",
				},
				minRemainingBalance: {
					label: "Minimum available balance",
					placeholder: "$ 0.00",
				},
				rfmClassification: {
					label: "RFM Classification",
					placeholder: "Select a classification",
				},
			},
			actions: {
				save: "Save",
				cancel: "Cancel",
				saving: "Saving...",
			},
			validation: {
				nameRequired: "Name is required",
				descriptionRequired: "Description is required",
				analysisPeriodRequired: "Analysis period is required",
				analysisPeriodMin: "Period must be greater than 0",
			},
		},
		deleteModal: {
			title: "Delete segment",
			message:
				'Are you sure you want to delete the segment "{{name}}"? This action cannot be undone.',
			confirm: "Delete",
			cancel: "Cancel",
			deleting: "Deleting...",
		},
		empty: {
			title: "No segments found",
			description: "Create your first segment to start organizing your customers.",
			searchEmpty: "No segments match your search.",
		},
		toast: {
			createSuccess: "Segment created successfully",
			updateSuccess: "Segment updated successfully",
			deleteSuccess: "Segment deleted successfully",
		},
	},
};
